import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface McpTraceEvent {
    at: string;
    type: string;
    requestId?: string;
    detail?: string;
    data?: Record<string, any>;
}

@Injectable({ providedIn: 'root' })
export class McpTraceService {
    private readonly _events = new BehaviorSubject<McpTraceEvent[]>([]);

    get events$(): Observable<McpTraceEvent[]> {
        return this._events.asObservable();
    }

    getSnapshot(): McpTraceEvent[] {
        return this._events.value;
    }

    log(
        type: string,
        data?: Record<string, any>,
        options?: { requestId?: string; detail?: string }
    ): void {
        const next: McpTraceEvent[] = [
            ...this._events.value,
            {
                at: new Date().toISOString(),
                type,
                requestId: options?.requestId,
                detail: options?.detail,
                data,
            },
        ].slice(-300);

        this._events.next(next);
    }

    clear(): void {
        this._events.next([]);
    }
}
